/* eslint-disable import/prefer-default-export */
export const ROUTES_PATH = {
  ROOT: '/',
};
